"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterCriteriaSchema = exports.BaseFilterCriteriaSchema = void 0;
const zod_1 = require("zod");
const objectQuery_1 = require("./objectQuery");
exports.BaseFilterCriteriaSchema = zod_1.z.record(zod_1.z.union([objectQuery_1.ObjectQuerySchema, zod_1.z.string(), zod_1.z.number(), zod_1.z.boolean()]));
exports.FilterCriteriaSchema = exports.BaseFilterCriteriaSchema.or(objectQuery_1.LogicalObjectQuerySchema.strict());
//# sourceMappingURL=filterCriteria.js.map